import { ErrorBoundary } from './../../components-common/errors/ErrorBoundary';
import { PageContainer } from './../../components-common/layout/views/Page';
import { ScreenProps } from './../../components-common/_types/screens/screen';
import { protectedRoute } from '../../_runtime/routing/ProtectedRoute';

export const emptyScreenTemplate: ScreenProps = {
  cat: 'screen',
  type: 'custom',
  id: 'NOT_SET',
  view: {
    cat: 'page',
    type: 'page',
    Component: PageContainer,
  },
  route: {
    id: '',
    label: '',
    to: '/errors/template-not-set',
    roles: [],
    protected: true,
    entityId: 'NOT_SET',
    component: 'NOT_SET',
  },
  components: {
    protected: protectedRoute,
    errorBoundary: ErrorBoundary,
  },
};
